import { Grid } from "@mui/material";
import React, { memo, useEffect, useRef, useState, useTransition } from "react";
import { Mention, MentionsInput } from "react-mentions";

interface Props {
  mentionUsers: any;
  comment: any;
  setComment: any;
  setTyping: any;
  isTyping: any;
}
const CommentInput = ({
  mentionUsers,
  comment,
  setComment,
  setTyping,
  isTyping,
}: Props) => {
  //   const [x, setX] = useState<any>();
  //   useEffect(() => {
  //     setTimeout(() => {
  //       setComment(x);
  //     }, 100);
  //   }, [x]);

  return (
    <>
      <Grid item xs={10} width={"100%"} height={"100%"}>
        <MentionsInput
          style={{
            background: "#fff",
            width: "100%",
            // height: "50px",

            border: "none",
            borderRadius: "5px",
            maxHeight: "180px",
          }}
          //   onKeyDown={(e: any) => (e.key === "Enter" ? handleSendMessage() : "")}
          value={comment}
          onChange={(event) => {
            setComment(event.target.value);
            // setX(event.target.value);
            if (event.target.value !== "") {
              setTyping(true);
            } else {
              setTyping(false);
            }
            // setX(event.target.value);
          }}
          className="mentions"
          // classNames={Style}
          placeholder="متن پیگیری ..."
          allowSuggestionsAboveCursor={true}

          // allowSpaceInQuery
        >
          <Mention
            appendSpaceOnAdd={true}
            className="mentionedUsers"
            data={mentionUsers}
            trigger="@"
            displayTransform={(id, display) => `@ ${display}`}
            // style={{ color: "red" }}
            // markup="@[__display__]"
            renderSuggestion={(
              suggestion,
              search,
              highlightedDisplay,
              index,
              focused
            ) => (
              <div>
                {suggestion.id.toString().search(/female/i) !== -1 ? (
                  <img
                    src="/images/person_3_black_24dp.svg"
                    alt="avatar"
                    className="mentions-avatar"
                  />
                ) : (
                  <img
                    src="/images/person_black_24dp.svg"
                    alt="avatar"
                    className="mentions-avatar"
                  />
                )}

                {highlightedDisplay}
              </div>
            )}
          />
        </MentionsInput>
      </Grid>
    </>
  );
};

export default CommentInput;
